import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectIsDesktop } from '~/components/brand/ducks/selectors.js';
import useUIContext from '~/ui/use-ui-context.ts';
import SupportButton from './support-button.js';

/**
 * @param {string} pos
 * Function to slide the zendesk widget by an extra 375px when the sidebar opens
 */
const slideZendesk = (pos = '4px') => {
	window.zE('webWidget', 'updateSettings', {
		webWidget: {
			offset: {
				horizontal: pos
			}
		}
	});
};

const slideAda = (pos = '0px') => {
	/*
	 *	we use setTimeout because it takes a split second for the widget to show up
	 * 	in the DOM after the 'loaded' event is fired
	 */
	setTimeout(() => {
		const adaFrame = document.querySelector('#ada-chat-frame');

		if (adaFrame) {
			adaFrame.style.right = pos;
		}
	}, 100);
};

const slideDixa = (offSet = '0px', messengerToken) => {
	// this doesn't work
	// window._dixa_.invoke('setPosition', { horizontalPadding: offSet, position: 'bottomRight' });
	// so we have to do it manually
	const dixaMessenger = document.querySelector(`#dixa-messenger-widget-wrapper-${messengerToken}`);

	if (dixaMessenger) {
		dixaMessenger.style.right = offSet;
	}
};

const FloatingSupportButton = () => {
	const isDesktop = useSelector(selectIsDesktop);
	const support = useSelector(state => state.support);
	const { showSidebar } = useUIContext();

	useEffect(() => {
		if (support.supportLoaded) {
			const rightOffset = showSidebar && isDesktop ? '379px' : undefined;
			if (support.ada) {
				slideAda(rightOffset);
			} else if (support.zendesk) {
				slideZendesk(rightOffset);
			} else if (support.dixa) {
				slideDixa(rightOffset, support.dixa.messengerToken);
			}
		}
	}, [support, showSidebar, isDesktop]);

	return <SupportButton />;
};

export default FloatingSupportButton;
